module.exports = [
    "None",
    "Bearing",
    "Electric Motor",
    "GearBox",
    "Pump",
    "Roll",
    "Fan",
    "Pulley",
    "Spindle",
    "pulley-belt"]